import React, { useEffect, useState } from "react";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";

export default function Account() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/my").then((res) => setOrders(res.data));
  }, []);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display font-semibold text-2xl mb-2">Hi, {user.name}</h1>
      <p className="text-white/50 text-sm mb-8">{user.email}</p>
      <button onClick={logout} className="text-sm text-red-400 mb-8">Sign out</button>
      <h2 className="font-display font-semibold text-lg mb-4">Order history</h2>
      <div className="space-y-3">
        {orders.map((o) => (
          <div key={o._id} className="flex justify-between text-sm bg-surface border border-white/10 rounded-lg p-4">
            <span className="font-mono text-white/60">#{o._id.slice(-6)}</span>
            <span>{o.status}</span>
            <span className="font-mono">₹{o.totalPrice.toFixed(2)}</span>
          </div>
        ))}
        {orders.length === 0 && <p className="text-white/40 text-sm">No orders yet.</p>}
      </div>
    </div>
  );
}
